import { Loader } from 'component/customComponents/loader/loader';
import React, { ReactElement, Suspense, lazy } from 'react';

const LazyTechnicalRequirements = lazy(() =>
  import('./technicalRequirements')
    .then((module) => ({ default: module.TechnicalRequirements }))
    .catch(() => {
      document.location.reload();
      return { default: () => <></> };
    })
);

export const TechnicalRequirements = (): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyTechnicalRequirements />
  </Suspense>
);
